import { useEffect, useState, useSyncExternalStore } from 'react';

const RECHECK_EVENTS = ['online', 'offline', 'focus', 'visibilitychange', 'pageshow'] as const;

function subscribe(onChange: () => void): () => void {
  for (const event of RECHECK_EVENTS) window.addEventListener(event, onChange);
  return () => {
    for (const event of RECHECK_EVENTS) window.removeEventListener(event, onChange);
  };
}

function getSnapshot(): boolean {
  return navigator.onLine;
}

async function probeNetwork(): Promise<boolean> {
  try {
    const res = await fetch(`/manifest.json?ts=${Date.now()}`, {
      cache: 'no-store',
      credentials: 'same-origin',
    });
    return res.ok;
  } catch {
    return false;
  }
}

export function useOnlineStatus(): boolean {
  const browserOnline = useSyncExternalStore(subscribe, getSnapshot, () => true);
  const [confirmedOffline, setConfirmedOffline] = useState(false);

  if (browserOnline && confirmedOffline) {
    setConfirmedOffline(false);
  }

  useEffect(() => {
    if (browserOnline) return;
    let cancelled = false;
    const check = async () => {
      const reachable = await probeNetwork();
      if (!cancelled) setConfirmedOffline(!reachable);
    };
    void check();
    const id = window.setInterval(() => void check(), 10_000);
    return () => {
      cancelled = true;
      window.clearInterval(id);
    };
  }, [browserOnline]);

  return browserOnline || !confirmedOffline;
}
